module.exports = __webpack_public_path__ + "static/TALDesignThinking-d662673be9ddf87237917e5d5e09898d.jpg";